import { z } from 'zod';
import { SlackUserIdSchema } from '../common/schemas';

/**
 * DB Schemas
 */

export const DBSlackConfigUserIdSchema = SlackUserIdSchema;
export const DBSlackConfigKarmaSchema = z.number().int();
/** The highest karma milestone already announced for the member. */
export const DBSlackConfigCelebratedSchema = z.number().int().nonnegative();

export const DBSlackConfigSchema = z.object({
  userId: DBSlackConfigUserIdSchema,
  karma: DBSlackConfigKarmaSchema,
  celebrated: DBSlackConfigCelebratedSchema.optional(),
});

/**
 * Client Schemas
 */

export const SlackConfigUserIdSchema = DBSlackConfigUserIdSchema;
export const SlackConfigKarmaSchema = DBSlackConfigKarmaSchema;
export const SlackConfigCelebratedSchema = DBSlackConfigCelebratedSchema;

export const SlackConfigSchema = z.object({
  userId: SlackConfigUserIdSchema,
  karma: SlackConfigKarmaSchema,
  celebrated: SlackConfigCelebratedSchema.optional(),
});
